// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"df055258","513":"5e3e25c7","703":"bfcd1f6d","921":"dac3b4e9"}[chunkId] + ".chunk.js";
};